import { useEffect } from "react";
import { useLocation } from "wouter";
import "./prism-product-shell.css";

const PRODUCT_VERSION = "2.5";

const NAV: Array<[string, string]> = [
  ["/", "Dashboard"],
  ["/control-room", "Control Room"],
  ["/correlation-map", "Correlation Map"],
  ["/bidirectional-core", "Bidirectional Core"],
  ["/provenance", "Provenance"],
  ["/export", "Export"],
];

function routeLabel(path: string): string {
  if (path.startsWith("/instance/")) return "Verification Workspace";
  const match = NAV.find(([href]) => href === "/" ? path === "/" : path.startsWith(href));
  return match?.[1] || "Prism";
}

export default function PrismProductShell({ children }: { children: React.ReactNode }) {
  const [path, navigate] = useLocation();

  useEffect(() => {
    document.title = `PRISM V${PRODUCT_VERSION} — ${routeLabel(path)}`;
  }, [path]);

  return <div className="pps-root">
    <header className="pps-header">
      <button className="pps-brand" onClick={() => navigate("/")}>
        <span className="pps-mark" aria-hidden="true">◇</span>
        <span><b>PRISM V{PRODUCT_VERSION}</b><small>Deterministic civic intelligence verification</small></span>
      </button>
      <nav aria-label="Prism product navigation">
        {NAV.map(([href, label]) => {
          const active = href === "/" ? path === "/" : path.startsWith(href);
          return <button key={href} className={active ? "active" : ""} onClick={() => navigate(href)}>{label}</button>;
        })}
      </nav>
    </header>
    <div className="pps-content">{children}</div>
  </div>;
}
